var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mouse_setting"},[_c('language'),_c('device-info'),_c('pair'),_c('sleep-time'),_c('advanced-setting',{directives:[{name:"show",rawName:"v-show",value:(_vm.longDistanceShow),expression:"longDistanceShow"}]}),_c('company-info')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }